import React, { useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FiSearch } from 'react-icons/fi';
//import { FiPlus } from 'react-icons/fi';
//import { FiEdit3 } from 'react-icons/fi';
//import { PiPlusCircleFill } from 'react-icons/pi';
//import { FaTimes } from 'react-icons/fa';
//import BottomTab from '../components/BottomTab';
import { useNavigate } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
//import { getAccessToken } from '../react-queries/queries';
//import { processApiResponse } from '../common/errorMessage';
//import { getBookeventsByHashtag } from '../api/BookeventApi';
//import { BookEventType } from '../common/enums';
//import ReviewMoimDetailPage from './ReviewMoimDetailPage';
import ReviewMoimPage from './ReviewMoimPage';
import CommunityMoimPage from './CommunityMoimPage';
import CommunityMoimSearchResultPage from './CommunityMoimSearchResultPage';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;
const TopSection = styled.div`
  background: #eae8e9;
`;
const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #3e3e3e;
  margin: 12px 0 0 0;
  padding-left: 16px;
  margin-bottom: 12px;
  padding-bottom: 10px;
`;
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  margin: 0 20px 18px 20px;
  padding: 0 16px;
  height: 48px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  flex: 1;
  margin-left: 10px;
  &::placeholder {
    font-size: 14px;
    color: #bdbdbd;
  }
`;
const TabRow = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 0 0;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
`;
const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;


const ContentSection = styled.div`
  background: #fff;
  padding-bottom: 80px;
`;


export function MoimMainPage() {
  const [tab, setTab] = useState('review');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [finalSearchKeyword, setFinalSearchKeyword] = useState('');
  const handleTab = t => setTab(t);
  //const navigate = useNavigate();
  const {showBack, setShowBack } = useNoobookContext();
  
  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(false);
    return () => {
      setShowBack(prevShowBack);
    };
  }, []);

  

  // 검색어 입력 처리
  const handleSearchInputChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  // 검색어 입력 후 Enter 키 처리
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      setFinalSearchKeyword(searchKeyword);
      console.log(searchKeyword);
      //searchBookevents();
    }
  };
  

  return (
    <PageWrapper>
      <TopSection>
        <Title>{tab === 'recommend' ? '내 취향을 발견해 보세요' : '내 취향을 발견해 보세요'}</Title>
        <SearchBox>
          <FiSearch size={20} color="#888" />
          <SearchInput 
            placeholder={tab === 'recommend' ? "주제별, 장르별, 독서모임으로 검색해 보세요" : "주제별, 장르별, 서평단으로 검색해 보세요"} 
            value={searchKeyword}
            onChange={handleSearchInputChange}
            onKeyPress={handleSearchKeyPress}
          />
        </SearchBox>
        <TabRow>
          <Tab active={tab==='review'} onClick={()=>handleTab('review')}>서평·필사단</Tab>
          <Tab active={tab==='recommend'} onClick={()=>handleTab('recommend')}>추천모임</Tab>
        </TabRow>
      </TopSection>
      <ContentSection>
        {tab === 'review' && (
          <ReviewMoimPage keyword={finalSearchKeyword} />
        )}
        {tab === 'recommend' && 
        ((finalSearchKeyword && 
          <CommunityMoimSearchResultPage keyword={finalSearchKeyword} />
        ) || <CommunityMoimPage />)}
      </ContentSection>
    </PageWrapper>
  );
}

export default MoimMainPage; 